import React, { useState, useEffect } from 'react';
import { Box, CardContent, Card, Typography, Button, Link } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid';
import jwt from 'jwt-decode';
import { getLocalStorageItem } from '../../common/localStorageUtils';
import { getPaymentStatus } from './paymentAPIs';
import { PROD } from '../../common/constants';
import CustomDataGridToolbar from '../../common/customDataGridToolbar';
import { useTranslation } from 'react-i18next';
import { lastFiveDigitsComparator } from '../../common/commonFunction';
import { useNavigate } from 'react-router-dom';

function PaymentStatusStakeholderUser() {
  const {t} = useTranslation();
  const [urn, setUrn] = useState("");
  const [paymentStatusDetails, setPaymentStatusDetails] = useState();

  const navigate = useNavigate();

  useEffect(() => {
    if (getLocalStorageItem('id_token')) {
      const decoded = jwt(getLocalStorageItem('id_token'));
      setUrn(decoded.extension_URN)
    }
  }, [getLocalStorageItem('id_token')]);

  const viewURNDetails = (urn) => {
    navigate("./viewPageWraper", { state: { urn: urn, goBack: true } });
  }

  const columns = [
    { field: 'urn', headerName: t('payment.urn'), width: 180, sortComparator: (a, b) => lastFiveDigitsComparator(a, b),
    renderCell: (params) => { return (<Link to={params} onClick={() => { viewURNDetails(params?.row?.urn) }}>{params.value}</Link>) }},
    { field: 'referenceNumber', headerName: t('payment.referenceNo'), width: 150 },
    { field: 'livNo', headerName: t('payment.liv Number'), width: 150 },
    { field: 'paymentType', headerName: t('payment.typeOfPayment'), width: 150 },
    { field: 'stakeholderCategory', headerName: t('payment.stakeholderCategory'), width: 200 },
    { field: 'totalAmount', headerName: t('payment.amountINR'), width: 120, type: "number",
    valueGetter: (params) => params.value?.toFixed(2),
   },
    { field: 'createdOn', headerName: t('payment.creationDate'), width: 200 },
    { field: 'paymentDate', headerName: t('payment.paymentDate'), width: 180 },
    { field: 'status', headerName: t('payment.status'), width: 200 },
    { field: 'paymentId', headerName:t('payment.status'), width: 150, hide: true },
    { field: 'bankTransactionId', headerName: t('payment.bankTransactionId'), width: 250 }
  ];

  useEffect(() => {
    if (urn) {
      getPaymentStatus(urn, setPaymentStatusDetails)
    }
  }, [urn]);

  return (
    <>
      {!PROD && <p style={{ textAlign: "right", fontSize: "2vh" }}>PAY07</p>}
      <Card>
        <CardContent>
          <Typography variant="h4" gutterBottom>
            {t('payment.paymentStatus')}
          </Typography>
          {paymentStatusDetails && <Box style={{ height: 500, width: '100%' }}>
            <DataGrid
              rows={paymentStatusDetails?.paymentStatus}
              columns={columns}
              pageSize={10}
              getRowId={(row) => row.paymentId}
              components={{
                Toolbar: CustomDataGridToolbar,
              }}
              componentsProps={{ toolbar: { rows: paymentStatusDetails?.paymentStatus, columns: columns, fileName: "Payment.xlsx" } }}
            />
          </Box>}
        </CardContent>
      </Card>
    </>
  )
}

export default PaymentStatusStakeholderUser;